module.exports = __webpack_public_path__ + "img/icon-1.4e0c3d84.png";